export default "__VITE_ASSET__CjpujuXQ__"